import { useCallback, useMemo } from "react";
import { PermissionEnum } from "types/enums";

import { useUser } from "./useUser";

export function usePermission() {
    const userUtils = useUser();
    const userPermissions = userUtils?.getActiveTenant()?.userPermissions || [];

    const permissionSet = useMemo(() => {
        return new Set(userPermissions.map((p) => p.name));
    }, [userPermissions]);

    const hasPermission = useCallback(
        (permissionName: PermissionEnum) => {
            return permissionSet.has(permissionName);
        },
        [permissionSet]
    );

    const hasAtLeastOnePermission = useCallback(
        (permissions: PermissionEnum[]) => {
            if (!permissions || permissions.length === 0) {
                return false;
            }
            return permissions.some(permission => permissionSet.has(permission));
        },
        [permissionSet]
    );

    return { hasPermission, hasAtLeastOnePermission };
}
